<div class="lottie-container" [ngStyle]="{ width: width ? width + 'px' : '100%', height: height ? height + 'px' : '100%' }" #lottieContainer></div>
